import React, { Component } from 'react';
import EphielNavBar from "./components/EphielNavBar";
import JumbotronBanner from "./components/JumbotronBanner";
import Features from "./components/Features";
import FormPart from "./components/FormTwo";
import { Container, Row, Col } from "reactstrap";
import AlertMainPage from "./components/AlertMainPage"
import { Provider } from "react-redux";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';

class App extends Component {
  componentDidMount() {
  }
  render() {
    return(
      
      <Provider store={store}>
        <div className="App">
        <EphielNavBar />
        <AlertMainPage />
       
          <Container>
            <Row>
              <Col xs="12" sm="6">
              {/* <Banner/> */}
              <JumbotronBanner/>
              <Features/>
            {/* <Pricing/> */}
              </Col>
              <Col xs="12" sm="6">
              <FormPart/>
              </Col>
            </Row>
            
          </Container>
        </div>
      </Provider>
    );
  }
}


export default App;
